module.exports = __webpack_public_path__ + "static/media/majorD2.27d280a.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorD2.wav
// module id = AOFL
// module chunks = 0